export default __webpack_public_path__ + "static/media/worldmap.a10b97af.png";